@if (isLoading) {
  <div class="flex justify-center items-center h-full">
    <app-loader></app-loader>
  </div>
}

@if (!isLoading && !!results && !!results.length) {
  <div class="h-full flex flex-col">
    <div class="flex-shrink-0 p-4 pb-0">
      @if (resubmittedWithoutFilters) {
        <div class="flex gap-4 items-center border-solid border border-[#8ABAFA] rounded-2xl p-4 mb-4">
          <img src="/assets/images/maslulan_empty_state.svg" alt="" class="h-10">
          <span class="text-start" >
            {{reSearchWithoutFiltersText}}
          </span>
        </div>
      }
      <app-tariff-profile-selector
        (onToggleChange)="togglePriceCalculation()"
        [priceCalculationLabel]="priceCalculationLabel"
        [showRoutePrice]="showRoutePrice"
        [dir]="direction"
        [priceProfileFormControl]="priceProfileFormControl"
        class="!mb-4"
        />
      </div>
      <div class="flex-1 overflow-y-auto px-4 pb-4 use-scrollbar">
        <div class="flex flex-col gap-2">
          @for (result of results; track result) {
            <app-source-destination-results-list-item
              [route]="result"
              [showRoutePrice]="showRoutePrice"
              [selectedProfile]="selectedProfile"
              (cardActivate)="onResultClick.emit({ route: result, showRoutePrice })"
              (cardHover)="onResultHover.emit(result)"
              />
          }
        </div>
      </div>
    </div>
  }

  @if (!isLoading && (!results || !results.length)) {
    <app-no-results [noResultsForWhatText]="noResultForText" />
  }
